import { PostsMedia } from "../types/api/PostMedia";

export function isVideo(media: PostsMedia) {
  return (
    media.mine_type?.includes("video") ||
    isVideoFromThumbnail(media.src_thumbnail || "")
  );
}

export function isVideoFromThumbnail(url: string) {
  return url.endsWith(".video-thumbnail.jpg");
}

export function getVideoFromThumbnailUrl(url: string) {
  return url
    .replace(/\/media\/\w+\//g, "/media/video/")
    .replace(".video-thumbnail.jpg", "");
}
